import { render, staticRenderFns } from "./RadioDestinationExt.vue?vue&type=template&id=32e848f2&lang=pug"
import script from "./RadioDestinationExt.vue?vue&type=script&lang=js"
export * from "./RadioDestinationExt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports